namespace $ {
	export class $aspirity_account_browse extends $mol_page {
		
		/**
		 * ```tree
		 * filter false
		 * ```
		 */
		filter() {
			return false
		}
		
		/**
		 * ```tree
		 * domain $aspirity_account_domain
		 * ```
		 */
		@ $mol_mem
		domain() {
			const obj = new this.$.$aspirity_account_domain()
			
			return obj
		}
		
		/**
		 * ```tree
		 * title @ \Invoices
		 * ```
		 */
		title() {
			return this.$.$mol_locale.text( '$aspirity_account_browse_title' )
		}
		
		/**
		 * ```tree
		 * tools /
		 * 	<= New
		 * 	<= Filter_toggle
		 * 	<= Sign_out
		 * ```
		 */
		tools() {
			return [
				this.New(),
				this.Filter_toggle(),
				this.Sign_out()
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * body <= page_body
		 * ```
		 */
		body() {
			return this.page_body()
		}
		
		/**
		 * ```tree
		 * Link!id $mol_link
		 * 	arg * invoice <= invoice_link!id
		 * 	sub / <= Invoice_title!id
		 * ```
		 */
		@ $mol_mem_key
		Link(id: any) {
			const obj = new this.$.$mol_link()
			
			obj.arg = () => ({
				invoice: this.invoice_link(id)
			})
			obj.sub = () => [
				this.Invoice_title(id)
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * Filter $mol_view sub / <= Search
		 * ```
		 */
		@ $mol_mem
		Filter() {
			const obj = new this.$.$mol_view()
			
			obj.sub = () => [
				this.Search()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * New_icon $mol_icon_plus
		 * ```
		 */
		@ $mol_mem
		New_icon() {
			const obj = new this.$.$mol_icon_plus()
			
			return obj
		}
		
		/**
		 * ```tree
		 * New $mol_link
		 * 	arg * new \
		 * 	sub / <= New_icon
		 * ```
		 */
		@ $mol_mem
		New() {
			const obj = new this.$.$mol_link()
			
			obj.arg = () => ({
				new: ""
			})
			obj.sub = () => [
				this.New_icon()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * Filter_toggle_icon $mol_icon_filter
		 * ```
		 */
		@ $mol_mem
		Filter_toggle_icon() {
			const obj = new this.$.$mol_icon_filter()
			
			return obj
		}
		
		/**
		 * ```tree
		 * Filter_toggle $mol_link
		 * 	arg *
		 * 		filter \
		 * 		filter_subject null
		 * 		filter_company null
		 * 		filter_contractor null
		 * 	sub / <= Filter_toggle_icon
		 * ```
		 */
		@ $mol_mem
		Filter_toggle() {
			const obj = new this.$.$mol_link()
			
			obj.arg = () => ({
				filter: "",
				filter_subject: null as any,
				filter_company: null as any,
				filter_contractor: null as any
			})
			obj.sub = () => [
				this.Filter_toggle_icon()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * sign_out?val null
		 * ```
		 */
		@ $mol_mem
		sign_out(val?: any) {
			if ( val !== undefined ) return val as never
			return null as any
		}
		
		/**
		 * ```tree
		 * Sign_out_icon $mol_icon_logout_variant
		 * ```
		 */
		@ $mol_mem
		Sign_out_icon() {
			const obj = new this.$.$mol_icon_logout_variant()
			
			return obj
		}
		
		/**
		 * ```tree
		 * Sign_out $mol_button_typed
		 * 	click?val <=> sign_out?val
		 * 	sub / <= Sign_out_icon
		 * ```
		 */
		@ $mol_mem
		Sign_out() {
			const obj = new this.$.$mol_button_typed()
			
			obj.click = (val?: any) => this.sign_out(val)
			obj.sub = () => [
				this.Sign_out_icon()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * links /
		 * ```
		 */
		links() {
			return [
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * List $mol_list rows <= links
		 * ```
		 */
		@ $mol_mem
		List() {
			const obj = new this.$.$mol_list()
			
			obj.rows = () => this.links()
			
			return obj
		}
		
		/**
		 * ```tree
		 * page_body / <= List
		 * ```
		 */
		page_body() {
			return [
				this.List()
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * invoice_link!id \
		 * ```
		 */
		invoice_link(id: any) {
			return ""
		}
		
		/**
		 * ```tree
		 * invoice_title!id \
		 * ```
		 */
		invoice_title(id: any) {
			return ""
		}
		
		/**
		 * ```tree
		 * Invoice_title!id $mol_dimmer
		 * 	haystack <= invoice_title!id
		 * 	needle <= query
		 * ```
		 */
		@ $mol_mem_key
		Invoice_title(id: any) {
			const obj = new this.$.$mol_dimmer()
			
			obj.haystack = () => this.invoice_title(id)
			obj.needle = () => this.query()
			
			return obj
		}
		
		/**
		 * ```tree
		 * query?val \
		 * ```
		 */
		@ $mol_mem
		query(val?: any) {
			if ( val !== undefined ) return val as never
			return ""
		}
		
		/**
		 * ```tree
		 * suggests /
		 * ```
		 */
		suggests() {
			return [
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * Search $mol_search
		 * 	query?val <=> query?val
		 * 	suggests <= suggests
		 * ```
		 */
		@ $mol_mem
		Search() {
			const obj = new this.$.$mol_search()
			
			obj.query = (val?: any) => this.query(val)
			obj.suggests = () => this.suggests()
			
			return obj
		}
	}
	
	export class $aspirity_account_browse_select extends $mol_select {
		
		/**
		 * ```tree
		 * title \
		 * ```
		 */
		title() {
			return ""
		}
		
		/**
		 * ```tree
		 * Clear $mol_button_minor
		 * 	hint @ \Clear
		 * 	click?event <=> clear?event
		 * 	sub / <= Clear_icon
		 * ```
		 */
		@ $mol_mem
		Clear() {
			const obj = new this.$.$mol_button_minor()
			
			obj.hint = () => this.$.$mol_locale.text( '$aspirity_account_browse_select_Clear_hint' )
			obj.click = (event?: any) => this.clear(event)
			obj.sub = () => [
				this.Clear_icon()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * clear?event null
		 * ```
		 */
		@ $mol_mem
		clear(event?: any) {
			if ( event !== undefined ) return event as never
			return null as any
		}
		
		/**
		 * ```tree
		 * Clear_icon $mol_icon_cross
		 * ```
		 */
		@ $mol_mem
		Clear_icon() {
			const obj = new this.$.$mol_icon_cross()
			
			return obj
		}
	}
	
}

